import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedLine } from "../../redux/actions/shared-actions";
import {
  setBStaticFilteredData,
  setTBStaticFilteredData,
  setTMStaticFilteredData,
} from "../../redux/actions/static-data-actions";
import { useTranslation } from "react-i18next";
import { handleLineAutocompleteChange, translateLine } from "../../services/shared";
import { makeStyles } from "@material-ui/core/styles";

/**
 * Autocomplete text input used in the Drawer component.
 * @component
 * @category Components
 * @subcategory Navigation
 * @param {string} label  determines the mui autocomplete options data
 */

const LinesAutocomplete = ({ label }) => {
  const { t } = useTranslation();
  const useStyles = makeStyles((theme) => ({
    inputRoot: {
      '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
        paddingLeft: 26,
        color: "#fff",
      },
      "& .MuiOutlinedInput-root": {
        color: "#fff",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#fff",
        borderWidth: "2px",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#fff",
        borderWidth: "2px",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#fff",
        borderWidth: "2px",
      },
    },
    listbox: {
      backgroundColor: "#2c54a4",
      border: "2px solid white",
      borderRadius: "5px",
      fontFamily: '"Lucida Console", "Courier New", "monospace"',
      color: "white",
      '& .MuiAutocomplete-option[aria-selected="true"]': {
        // works
        backgroundColor: "#00000040",
      },
      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
        // works
        backgroundColor: "#00000040",
      },
      '& .MuiAutocomplete-option[aria-selected="false"].Mui-focused': {
        // works
        backgroundColor: "#00000040",
      },
    },
    paper: {
      marginTop: "10px",
    },
    noOptions: {
      backgroundColor: "#2c54a4",
      border: "2px solid white",
      borderRadius: "5px",
      fontFamily: '"Lucida Console", "Courier New", "monospace"',
      color: "white",
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();
  const { selectedLine, tramsData, trolleysData, busesData, naviagation } = useSelector((state) => ({
    selectedLine: state.shared.selectedLine,
    tramsData: state.staticData.TMData,
    trolleysData: state.staticData.TBData,
    busesData: state.staticData.BData,
    naviagation: state.navigation,
  }));

  const tramsOptions = ["ALL_TRAMS"];
  const trolleysOptions = ["ALL_TROLLEYS_AND_EBUSES"];
  const busesOptions = ["ALL_BUSES"];
  tramsData.forEach((line) => {
    tramsOptions.push(translateLine(line.line));
  });
  trolleysData.forEach((line) => {
    trolleysOptions.push(translateLine(line.line));
  });
  busesData.forEach((line) => {
    busesOptions.push(translateLine(line.line));
  });

  React.useEffect(() => {
    if (label === "TRAMS") {
      dispatch(setSelectedLine("ALL_TRAMS"));
    }
    if (label === "TROLLEYS_AND_EBUSES") {
      dispatch(setSelectedLine("ALL_TROLLEYS_AND_EBUSES"));
    }
    if (label === "BUSES") {
      dispatch(setSelectedLine("ALL_BUSES"));
    }
    return () => {
      if (!naviagation.greenCorridor1.isActive) {
        if (label === "TRAMS") {
          dispatch(setTMStaticFilteredData(tramsData));
        }
        if (label === "TROLLEYS_AND_EBUSES") {
          dispatch(setTBStaticFilteredData(trolleysData));
        }
        if (label === "BUSES") {
          dispatch(setBStaticFilteredData(busesData));
        }
      }
    };
    // eslint-disable-next-line
  }, [label, dispatch]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <br />
      <Autocomplete
        classes={classes}
        // isOptionEqualToValue={(option, value) => true}
        disablePortal
        value={translateLine(selectedLine)}
        onChange={(event, newValue) => {
          const [line, number] = newValue.split(" ");
          if (label === "TRAMS") {
            t(tramsOptions[0]) === newValue
              ? handleLineAutocompleteChange(tramsOptions[0], label)
              : handleLineAutocompleteChange(t(line) + number, label);
          }
          if (label === "TROLLEYS_AND_EBUSES") {
            t(trolleysOptions[0]) === newValue
              ? handleLineAutocompleteChange(trolleysOptions[0], label)
              : handleLineAutocompleteChange(t(line) + number, label);
          }
          if (label === "BUSES") {
            t(busesOptions[0]) === newValue
              ? handleLineAutocompleteChange(busesOptions[0], label)
              : handleLineAutocompleteChange(t(line) + number, label);
          }
        }}
        disableClearable
        id='lines-autocomplete'
        noOptionsText={t("NO_OPTIONS")}
        options={
          label === "TRAMS"
            ? tramsOptions.map((x) => (x = t(x)))
            : label === "TROLLEYS_AND_EBUSES"
            ? trolleysOptions.map((x) => (x = t(x)))
            : busesOptions.map((x) => (x = t(x)))
        }
        sx={{ width: 270 }}
        renderInput={(params) => <TextField {...params} label={t(label)} />}
      />
      <br />
    </div>
  );
};
export default React.memo(LinesAutocomplete);
